import {forwardRef, Inject, Injectable} from '@angular/core';
import {PollingBaseService} from '../../shared/models/polling-base-service.model';
import {HttpAuthService} from '../../shared/service/http-auth.service';
import {Observable} from 'rxjs/Observable';
import {Utilities} from '../../shared/utilities/utilities.model';
import {SelectCommoditiesService} from '@shared/service/select-commodities.service';
import {RequestOptions} from '@angular/http';
import {AppConfigEnvironment} from '@shared/models/appconfig-environment.model';
import {AppConfigEnvironmentService} from '@shared/service/appconfig-environment.service';
import { Appointments2FilterModel } from '../models/appointments2-filter.model';
import { Appointment2Model } from '../models/appointment.model';

@Injectable()
export class AppointmentsDashboardPollingService extends PollingBaseService {
	protected BASE_TIMER = 600000; //600s - 10m
    environment: AppConfigEnvironment;


	constructor(@Inject(forwardRef(() => HttpAuthService))   public httpAuthService: HttpAuthService,
				public selectCommoditiesService: SelectCommoditiesService,
                private appConfig: AppConfigEnvironmentService) {
		super();
        this.environment = appConfig.Environment;
	}

	settingPolling() {
		this.startPolling();
	}

	doAction() {
		this.getNewAppointmentsStats()
			.subscribe((itemsCount: number) => {
				this.lastResult = (itemsCount > 0) ? itemsCount : 0;
				this.pollingSubject.next(this.lastResult);
			});
	}

	getNewAppointmentsStats(): Observable<number> {
		// const url: string = environment.DELIVERY_APPOINTMENTS + '/appointments?status=planning&page_size=1&asc=false';
		// const url2: string = this.environment.APPOINTMENTS2 + '/appointments?status=planning&page_size=1&asc=0&type=DELIVERY';
		let url: string = this.environment.APPOINTMENTS2 + '/appointments';
		const appointmentFilter: Appointments2FilterModel = new Appointments2FilterModel();
		appointmentFilter.type = [Appointment2Model.APPOINTMENT_TYPE_DELIVERY];
		appointmentFilter.ald_supplier_id = this.selectCommoditiesService.getAldCommoditiesIds().toString();
		appointmentFilter.status = Appointment2Model.STATUS_PLANNING;
		url += appointmentFilter.getFilterUrl().replace(/\+/g, '%2B');
        const options = new RequestOptions();

		return new Observable<number>(
			observer => {
				this.httpAuthService.get(url, this.environment.ROOT_REDIRECT, options).subscribe(
					response => {
						if (!Utilities.isVoid(response) && response.status === 200) {
							try {
								observer.next(response.json().stats.item_count);
							} catch (error) {
								observer.error(error);
							}
						} else {
							observer.next(-1);
						}
					},
					error => {
						console.error(error);
						observer.next(-1);
					});
			});
	}

}
